import { AuthTranslationType } from "../../features/auth.types";

export const auth: AuthTranslationType = {
  auth: {
    cookieConsent: {
      title: "Cookie-Einwilligung",
      description: "Diese Website verwendet Cookies, um Ihr Browsererlebnis zu verbessern. Durch Klicken auf 'Akzeptieren' stimmen Sie der Verwendung von Cookies gemäß unserer Cookie-Richtlinie zu.",
      accept: "Cookies akzeptieren",
      readMore: "Um mehr zu erfahren, lesen Sie bitte unsere ",
      privacyPolicy: "Datenschutzrichtlinie",
      and: "und",
      termsOfService: "Nutzungsbedingungen"
    },
    title: {
      resetPassword: "Passwort Zurücksetzen",
      welcome: "Willkommen Zurück"
    },
    form: {
      displayName: "Anzeigename",
      email: "E-Mail",
      password: "Passwort",
      newPassword: "Neues Passwort",
      forgotPassword: "Passwort vergessen?",
      loading: "Wird geladen...",
      signIn: "Anmelden",
      signUp: "Registrieren",
      resetPassword: "Passwort Zurücksetzen",
      sendResetLink: "Link Zusenden",
      alreadyHaveAccount: "Bereits ein Konto? Anmelden",
      needAccount: "Benötigen Sie ein Konto? Registrieren",
      backToSignIn: "Zurück zur Anmeldung",
      orContinueWith: "Oder fortfahren mit",
      google: "Google",
      facebook: "Facebook",      
      privacyPolicyAgreement: "Durch Klicken auf Registrieren stimmen Sie zu",
      privacyPolicy: "Datenschutzrichtlinie",
      termsAgreement: "und",
      termsOfService: "Nutzungsbedingungen"
    },
    toast: {
      missingInfo: {
        title: "Fehlende Informationen",
        description: "Bitte geben Sie E-Mail und Passwort an."
      },
      missingName: {
        title: "Fehlende Information",
        description: "Bitte geben Sie einen Anzeigenamen an."
      },
      invalidEmail: {
        title: "Ungültige E-Mail",
        description: "Bitte geben Sie eine gültige E-Mail-Adresse ein."
      },
      invalidPassword: {
        title: "Ungültiges Passwort",
        description: "Das Passwort muss mindestens 6 Zeichen lang sein."
      },
      emailNotVerified: {
        title: "E-Mail nicht verifiziert",
        description: "Bitte überprüfen Sie Ihren Posteingang und klicken Sie auf den Bestätigungslink, um Ihre E-Mail zu verifizieren. Benötigen Sie einen neuen Link?",
        resend: "Erneut senden"
      },
      verificationEmailSent: {
        title: "Bestätigungs-E-Mail gesendet",
        description: "Bitte überprüfen Sie Ihren Posteingang für den Bestätigungslink."
      },
      loginFailed: {
        title: "Anmeldung fehlgeschlagen",
        description: "Ungültige E-Mail oder Passwort. Bitte versuchen Sie es erneut oder registrieren Sie sich, wenn Sie noch kein Konto haben."
      },
      displayNameTaken: {
        title: "Anzeigename vergeben",
        description: "Dieser Anzeigename wird bereits verwendet. Bitte wählen Sie einen anderen."
      },
      signUpSuccess: {
        title: "Erfolg",
        description: "Überprüfen Sie Ihre E-Mail für den Bestätigungslink!"
      },
      userAlreadyRegistered: {
        title: "Registrierung fehlgeschlagen",
        description: "Diese E-Mail ist bereits registriert. Bitte versuchen Sie, sich anzumelden."
      },
      resetEmailSent: {
        title: "Überprüfen Sie Ihre E-Mail",
        description: "Wir haben Ihnen einen Link zum Zurücksetzen des Passworts gesendet. Bitte überprüfen Sie Ihren Posteingang."
      },
      resetSuccess: {
        title: "Erfolg",
        description: "Ihr Passwort wurde erfolgreich zurückgesetzt. Bitte melden Sie sich mit Ihrem neuen Passwort an."
      },
      error: {
        title: "Fehler",
        description: "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es erneut."
      },
      googleLoginError: {
        title: "Google-Anmeldefehler",
        description: "Anmeldung mit Google nicht möglich. Bitte versuchen Sie es erneut."
      },
      facebookLoginError: {
        title: "Facebook-Anmeldefehler",
        description: "Facebook-Anmeldung konnte nicht initiiert werden. Bitte versuchen Sie es erneut."
      },
      samePassword: {
        title: "Gleiche Passwörter",
        description: "Das neue Passwort darf nicht mit dem alten Passwort übereinstimmen."
      },
      agreementRequired: {
        title: "Zustimmung erforderlich",
        description: "Sie müssen den Nutzungsbedingungen und der Datenschutzrichtlinie zustimmen."
      },
    }
  }
};
